/**
 * AUDIENCE ("Who We Help") DATA, Your Business
 * ──────────────────────────────────────────────────────────────────────────
 * Static, code-owned content for the home "Who We Help" section. This section
 * is NOT managed through the CMS/system_data, it rarely changes and its shape
 * (a fixed grid of audience chips) doesn't belong in the admin editor. Edit the
 * copy here and redeploy.
 *
 * Consumed by:
 *   Screens/Landing-screen/Landing.js        → <HomeAudience data={getAudienceData(lang)} />
 *   Screens/Home-Screen/home-screen.js       → <Audience data={getAudienceData(lang)} />
 *
 * Shape matches what audience-component.js expects:
 *   { eyebrow, titleLine1, titleLine2, paragraph, cards: [{ emoji, label, slug }] }
 */

const AUDIENCE_CARDS = [
    { emoji: '🏡', label: 'Item One', slug: 'item-one' },
    { emoji: '🏢', label: 'Item Two', slug: 'item-two' },
    { emoji: '🏦', label: 'Item Three', slug: 'item-three' },
    { emoji: '🏠', label: 'Item Four', slug: 'item-four' },
    { emoji: '⚖️', label: 'Item Five', slug: 'item-five' },
    { emoji: '🏗️', label: 'Item Six', slug: 'item-six' },
    { emoji: '💼', label: 'Item Seven', slug: 'item-seven' },
    { emoji: '🏬', label: 'Item Eight', slug: 'item-eight' },
];

const AudienceData = {
    en: {
        eyebrow: 'Who We Help',
        titleLine1: 'Headline goes here',
        titleLine2: 'Section Title',
        paragraph: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        cards: AUDIENCE_CARDS,
    },
    he: {
        eyebrow: 'Who We Help',
        titleLine1: 'Headline goes here',
        titleLine2: 'Section Title',
        paragraph: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        cards: AUDIENCE_CARDS,
    },
};

/** Static audience content for the given language (defaults to English). */
export function getAudienceData(lang = 'en') {
    return AudienceData[lang] || AudienceData.en;
}

export default AudienceData;
